import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import './Style/QuestionSolution.css';
import AllQuestions from '../AllData/AllQuestions';
import Latex from 'react-latex';
import TopNavbar from '../home/TopNavbar';
import QuestionImage from './QuestionImage';


const QuestionSolution = () => {
    const { id } = useParams();
    const questions = AllQuestions;

    const questionData = questions.find(
        submission => submission.id === id
    );



    const isData = !!questionData;
    const question = isData ? questionData.question : null;
    const question_img = isData ? questionData.question_img : null;
    const type = isData ? questionData.type : null;
    const year = isData ? questionData.year : null;
    const ans = isData ? questionData.answer : null;
    const solution = isData ? questionData.solution : null;
    const solutionimg = isData ? questionData.solutionimg : null;
    let answer = "";

    if (ans === "option1") { answer = isData ? questionData.option1 : null; }
    else if (ans === "option2") { answer = isData ? questionData.option2 : null; }
    else if (ans === "option3") { answer = isData ? questionData.option3 : null; }
    else if (ans === "option4") { answer = isData ? questionData.option4 : null; }




    const renderWithLatex = (text) => {
        if (!text) return null;

        if (text.includes('$') || text.includes('\\')) {
            return <Latex>{text}</Latex>;
        }
        return text;
    };


    const [showContent, setShowContent] = useState(false);
    const handleToggle = () => {
        setShowContent(!showContent);
    };

    return (
        <div className="solution-container">

            <TopNavbar name="Question solution" />

            <div className="question-details">
                {type === "dpp" || type === "yearrepeatedquestions" || (type === "previousyearquestions" && year === "2026") || (type === "previousyearquestions" && year === "2025") || (type === "previousyearquestions" && year === "2024") || (type === "previousyearquestions" && year === "2023") || (type === "previousyearquestions" && year === "2022") || (type === "previousyearquestions" && year === "2021") ? (<>
                    {question ? (
                        <p className="question-text">
                            {renderWithLatex(question)}
                        </p>
                    ) : (
                        <QuestionImage
                            src={`/questionsPhoto/${question_img}`}
                            alt="Question"
                        />
                    )}

                    <button onClick={handleToggle} style={{ fontSize: "8px", padding: "01px" }}>
                        {showContent ? "Hide source image" : "View source image"}
                    </button>
                    {showContent && (
                        <div style={{ padding: "5px" }}>
                            <QuestionImage
                                src={`/questionsPhoto/${question_img}`}
                                alt="Question"
                            />
                        </div>
                    )}

                </>) : (<>
                    {question_img ? (
                        <QuestionImage
                            src={`/questionsPhoto/${question_img}`}
                            alt="Question"
                        />
                    ) : (
                        <>{renderWithLatex(question)}</>
                    )}
                </>)}




            </div>

            <div className="answer-details">

                <p>Answer:  {renderWithLatex(answer)}</p>

            </div>


            <div className="solution-details">
                <p>Solution: Coming soon </p>

                {/*
                 {solutionimg ? (
                    <img src={`/solutionsimg/${solutionimg}.png`} alt="Solution" className='question-photo-solutin' />
                ) : (
                    <p> {renderWithLatex(solution)}</p>

                )}
                    */}




            </div>
        </div>

    );
};

export default QuestionSolution;